import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import UploadFile from "../images/uploadfile.png";
import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import SideMenu from "./SideMenu";
import Header from "./Header";
import Footer from "./Footer";
import Logout from "./Logout";
import Edit_Icon from "../images/edit_icon.svg";
import Eye_Red from "../images/View_Red.svg"
import searchIcon from "../images/search_icon.svg";
import { CustomDatePickerInput } from "../Utilities/utils.js";
import DatePicker from "react-datepicker";
import calendar_Icon from "../images/calendor_green.svg";
//for fontawesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBullseye,
  faEdit,
  faPlus,
  faEye,
  faL,
} from "@fortawesome/free-solid-svg-icons";

//for data table
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

//for modal
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal } from "react-bootstrap";
import '@fortawesome/fontawesome-free/css/all.min.css';

// Date
import "react-datepicker/dist/react-datepicker.css";
import {
  getUserMaster,
  addUserMaster,
  getUserTypeMaster,
  getRoleMaster,
  getUserSupportedMasters,
  resetPassword,
  getMasters,
  getManagerBasedOnCostCenter,
  getFunctionalLeadBasedOnCostCenter,
  getCostCenterBasedOnFunctionalLead,
  getEmployeeBasedOnManager,
  getEmployeeDetailsBasedOnName,
  getMainCropFunctionBasedOnEmployeeName,
  getSubCropFunctionBasedOnEmployeeName,
  getFileByPath
} from "../Utilities/URLCONSTANTS.js";
import Loader from "../Utilities/Loader";
import { GetApiHeaders, GetMediaImageBlobUrl, GetMediaImageUrl, ProtectedImage } from "../Utilities/NetworkUtilities";
import { GetApiHeadersWithToken } from "../Utilities/NetworkUtilities";
import moment from "moment";
import * as XLSX from "xlsx";
import { json } from "react-router-dom";
import { setDate } from "date-fns";
import { Alexa } from "react-bootstrap-icons";
import { customstyles, modalCustomStyles } from "../Utilities/utils.js";
import Select from "react-select";
import Add_Icon from "../images/Add_Icon.svg";
import {
  HiMiniArrowsUpDown,
  HiMiniArrowUp,
  HiMiniArrowDown,
} from "react-icons/hi2";
import Pagination from "../Utilities/Pagination.js";

//UserMaster
const UserMaster = () => {
  const [submitResponse, setsubmitResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showResponsePopup, setShowResponsePopup] = useState(false);

  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [Id, setId] = useState(0);
  const [userType, setUserType] = useState("");

  const [alternateMobileNo, setAlternateMobileNo] = useState("");
  const [errorfutureDate, setErrorfutureDate] = useState("");
  // const [dob, setDob] = useState();
  const [dob, setDob] = useState(null);
  const [mobileNumber, setMobileNumber] = useState("");
  const [gender, setGender] = useState("");
  const [address, setAddress] = useState("");
  const [status, setStatus] = useState("");

  //Email
  const [emailId, setEmailId] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [isUpdated, setIsUpdated] = useState(false);
  const [buttonText, setButtonText] = useState("Submit");
  const [showPopup, setShowPopup] = useState(false);
  const [showMsg, setShowMsg] = useState("false");
  const [showWarningPopup, setShowWarningPopup] = useState(false);

  //Errors

  const [errorFirstName, setErrorFirstName] = useState("");
  const [errorLastName, setErrorLastName] = useState("");
  const [errorUserType, setErrorUserType] = useState("");
  const [errorRoleType, setErrorRoleType] = useState("");
  const [errorMobileNumber, setErrorMobileNumber] = useState("");
  const [errorDob, setErrorDob] = useState("");
  const [errorAddress, setErrorAddress] = useState("");
  const [errorAlternateMobileNumber, setErrorAlternateMobileNumber] =
    useState("");
  const [errorEmailId, setErrorEmailId] = useState("");
  const [errorGender, setErrorGender] = useState("");
  const [errorStatus, setErrorStatus] = useState("");
  const [dynamicOptions, setDynamicOptions] = useState([]);
  const [roleType, setRoleType] = useState("");
  const [roleTypeOptions, setRoleTypeOptions] = useState([]);

  const [location, setLocation] = useState("");
  const [errorLocation, setErrorLocation] = useState("");
  const [locationTypeOptions, setLocationTypeOptions] = useState([]);
  const [subLocationTypeOptions, setSubLocationTypeOptions] = useState([]);

  const [costcenterID, setCostCenterID] = useState("");
  const [errorCostCenter, setErrorCostCenter] = useState("");
  const [costCenterOptions, setCostCenterOptions] = useState([]);

  const [cropID, setCropID] = useState();
  const [cropName, setCropName] = useState()
  const [subCropName, setSubCropName] = useState()
  const [errorCrop, setErrorCrop] = useState("");
  const [cropTypeOptions, setCropTypeOptions] = useState([]);

  const [subCropID, setSubCropID] = useState();
  const [errorSubCrop, setErrorSubCrop] = useState("");
  const [subCropTypeOptions, setSubCropTypeOptions] = useState([]);

  const [manager, setManager] = useState("");
  const [errorManager, setErrorManager] = useState("");
  const [managerTypeOptions, setManagerTypeOptions] = useState([]);

  const [profilePicUrl, setprofilePicUrl] = useState("");
  const [profilePicUrlShow, setprofilePicUrlShow] = useState("");
  const [errorProfilePicURL, setErrorProfilePicURL] = useState("");
  const [dmydob, setdmydob] = useState("");
  // const [dateOfJoining, setDateOfJoining] = useState("");
  const [dateOfJoining, setDateOfJoining] = useState(null);
  const [dmyDateOfJoining, setDmyDateOfJoining] = useState("");
  const [functionalLead, setFunctionalLead] = useState([]);
  const [errfunctionalLead, setErrFunctionalLead] = useState("");
  const [sublocation, setSublocation] = useState();
  const [errSubLocation, setErrSubLocation] = useState("");
  const [fetchMobile, setFetchMobile] = useState([])
  const [profileImages, setProfileImages] = useState({});
  const [modalData, setModalData] = useState({
    id: "",
    firstName: "",
    lastName: "",
    userType: "",
    roleType: "",
    mobileNumber: "",
    dob: "",
    address: "",
    alternateMobileNo: "",
    emailId: "",
    gender: "",
    status: "",
  });

  const [data, setData] = useState([]);
  const [loaderImage, setLoaderImage] = useState(
    require("../images/cs_loader.gif")
  );
  const [filteredData, setFilteredData] = useState([]); // For filtered results
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default: 10 items per page
  const [searchTerm, setSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState();
  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const [showResetForm, setShowResetForm] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [showModal, setShowModal] = useState(false);
  const [newDateOfJoining, setNewDateOfJoining] = useState();
  const [errDateOfJoining, setErrDateOfJoining] = useState("");
  const [costName, setCostName] = useState();
  const [functionalLeadName, setFunctionalLeadName] = useState();
  const [getEmployee, setGetEmployee] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState();
  const [subLocationId, setSubLocationId] = useState();
  const [locationId, setLocationId] = useState();

  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
    if (data) {
      const search = searchTerm.toLowerCase();
      const filteredResults = data.filter((item) => {
        const values = [
          item.firstName,
          item.managerName,
          item.userType,
          item.roleTypeName,
          item.locationName,
          item.costCenterName,
          item.cropName,
          item.subCropName,
          item.mobileNumber,
          item.dob,
          item.address,
          item.alternateMobileNo,
          item.emailId,
          item.gender,
          item.profilePicUrlPath,
          item.status,
        ];
        return values.some((value) =>
          String(value ?? "").toLowerCase().includes(search)
        );
      });

      setFilteredData(filteredResults);
      handlePageClick(1);
    }
  };

  useEffect(() => {
    if (data != null && data != undefined) {
      setFilteredData(data);
      setTotalItems(data.length);
    }
  }, [data]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1);
  };

  const pageNumbers = [];
  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(Math.ceil(totalItems / itemsPerPage) - 1, currentPage + 1);
    i++
  ) {
    pageNumbers.push(i);
  }

  const handlePageClick = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(totalItems / itemsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const handleEmployee = (e) => {
    setSelectedEmployee(e.target.value);
    if (e.target.value) {
      setErrorFirstName("");
    }
  };

  const fetchCropType = async () => {
    const apiFetch = getMainCropFunctionBasedOnEmployeeName;
    const headers = await GetApiHeaders();
    const postData = {
      employeeName: selectedEmployee,
      functionalLead: functionalLeadName,
      manager: manager
    }
    try {
      const response = await axios.post(apiFetch, postData, { headers })
      console.log("fetchcroptype", response);
      setCropTypeOptions(response.data.response)
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchCropType();
  }, [selectedEmployee]);

  const fetchSubCropType = async () => {
    const apisubcrop = getSubCropFunctionBasedOnEmployeeName;
    const headers = await GetApiHeaders();
    const post = {
      cropName: cropName ? cropName.toString() : "",
      cropID: cropID ? cropID.toString() : "",
    };
    try {
      const response = await axios.post(apisubcrop, post, { headers })
      setSubCropTypeOptions(response.data.response)
      console.log(response, 'subcrop');
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    fetchSubCropType();
  }, [cropID]);


  const fetchEmployee = async () => {
    const apiEmployee = getEmployeeBasedOnManager;
    const headers = await GetApiHeaders();
    const postData = {
      functionalLead: functionalLeadName,
      name: costcenterID,
      manager: manager,
    };
    try {
      const response = await axios.post(apiEmployee, postData, { headers });
      console.log("employee Data==>", response);
      if (response.data.response) {
        setGetEmployee(response.data.response);
      } else {
        console.log("Response is null or undefined");
      }
    } catch (error) {
      console.log(error);
    }
  };

  // console.log(getEmployee + "emple");
  console.log("getEmployee:", getEmployee);
  useEffect(() => {
    fetchEmployee();
  }, [costcenterID, functionalLeadName, manager]);

  const fetchManager = async () => {
    const managerApi = getManagerBasedOnCostCenter;
    const headers = await GetApiHeaders();

    const postData = {
      name: costcenterID,
      functionalLead: functionalLeadName,
    };

    try {
      const response = await axios.post(managerApi, postData, { headers });

      console.log("managerResponse", response);

      if (response.data.response) {
        setManagerTypeOptions(
          Array.isArray(response.data.response)
            ? response.data.response
            : []
        );
      } else {
        console.log("Response is null or undefined");
        setManagerTypeOptions([]);
      }
    } catch (error) {
      console.log(error);
      setManagerTypeOptions([]);
    }
  };

  useEffect(() => {
    fetchManager();
  }, [costcenterID, functionalLeadName]);

  const fetchFunctionalLead = async () => {
    const functionalLeadApi = getCostCenterBasedOnFunctionalLead;
    const headers = await GetApiHeaders();
    const postData = {
      functionalLead: functionalLeadName,
    };
    try {
      const response = await axios.post(functionalLeadApi, postData, {
        headers,
      });
      console.log("response=ttt=>", response);
      setCostCenterOptions(response.data.response);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (functionalLeadName) {
      fetchFunctionalLead();
    }
  }, [functionalLeadName]);

  const exportToExcel = () => {
    const data = [
      [
        "S.no",
        "First Name",
        "Last Name",
        "Manager Name",
        "UserType",
        "RoleType Name",
        "location Name",
        "cost Center",
        "Crop Name",
        "SubCrop Name",
        "Mobile Number",
        "Dob",
        "Date-Of-Joining",
        "Address",
        "Alternate MobileNo",
        "EmailId",
        "Gender",
        "ProfilePicUrl",
        "Status",
      ],
      ...filteredData.map((item, index) => [
        index + 1,
        item.firstName,
        item.lastName,
        item.managerName,
        item.userType === "1"
          ? "Requester"
          : item.userType === "2"
            ? "acceptor"
            : "none",
        item.roleTypeName,
        item.locationName,
        item.costCenterName,
        item.cropName,
        item.subCropName,
        item.mobileNumber,
        item.dob,
        item.dateOfJoining,
        item.address,
        item.alternateMobileNo,
        item.emailId,
        item.gender,
        // item.profilePicUrlPath,
        item.profilePicUrl,
        item.status === "1" ? "Active" : "InActive",
      ]),
    ];
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "UserMaster");
    XLSX.writeFile(wb, "UserMaster.xlsx");
  };

  const handleFirstNameChange = (e) => {
    const input = e.target.value;
    if (input.length > 0) {
      setErrorFirstName("");
    }
    const result = input.replace(/[^a-z_\s]/gi, "");
    setFirstName(result);
  };

  const handleLastNameChange = (e) => {
    const Name = e.target.value;
    if (Name.length > 0) {
      setErrorLastName("");
    }
    const result = Name.replace(/[^a-z_\s]/gi, "");
    setLastName(result);
  };

  const handleUserTypeChange = (e) => {
    setUserType(e.target.value.toString());
    const userInput = e.target.value;
    if (userInput.length > 0) {
      setErrorUserType("");
    }
    if (!isNaN(userInput)) {
      setUserType(userInput.toString());
    }
  };

  const handleRoleTypeChange = (e) => {
    setRoleType(e.target.value);
    const roleType = e.target.value;
    if (roleType.length > 0) {
      setErrorRoleType("");
    }
    if (!isNaN(roleType)) {
      setRoleType(roleType);
    }
  };

  const handleLocationTypeChange = (e) => {
    setLocation(e.target.value);
    const selectedLocationId =
      e.target.options[e.target.selectedIndex].getAttribute("data-locationId");
    setLocationId(selectedLocationId);
    const location = e.target.value;
    if (location.length > 0) {
      setErrorLocation("");
    }
    if (!isNaN(location)) {
      setLocation(location);
    }
  };

  const handleSubLocation = (e) => {
    setSublocation(e.target.value);
    const selectedSublocationId =
      e.target.options[e.target.selectedIndex].getAttribute(
        "data-sublocationId"
      );
    setSubLocationId(selectedSublocationId);
    if (e.target.value) {
      setErrSubLocation("");
    }
  };

  const handleCostCenterTypeChange = (e) => {
    setCostCenterID(e.target.value);
    const Center = e.target.value;
    const selectedcostCenter =
      e.target.options[e.target.selectedIndex].getAttribute(
        "data-costcentrName"
      );
    console.log("con", selectedcostCenter);
    setCostName(selectedcostCenter);
    if (Center.length > 0) {
      setErrorCostCenter("");
    }
    if (!isNaN(Center)) {
      setCostCenterID(Center);
    }
  };

  const handleFunctionalLead = (e) => {
    setFunctionalLeadName(e.target.value);
    if (e.target.value) {
      setErrFunctionalLead("");
    }
  };


  const handleCropTypeChange = (e) => {
    const crops = e.target.value;
    setCropID(crops);
    const cropName =
      e.target.options[e.target.selectedIndex]?.getAttribute("data-cropName");
    setCropName(cropName || "");
    // Clear validation
    if (crops !== "" && crops !== null && crops !== undefined) {
      setErrorCrop("");
    }
    if (!isNaN(crops) && crops !== "") {
      setCropID(crops);
    }
  };

  const handleSubCropTypeChange = (e) => {
    const subcrops = e.target.value;
    setSubCropID(subcrops);
    const subcropName =
      e.target.options[e.target.selectedIndex]?.getAttribute("data-subcropName");
    setSubCropName(subcropName || "");
    // Clear validation
    if (subcrops !== "" && subcrops !== null && subcrops !== undefined) {
      setErrorSubCrop("");
    }
    if (!isNaN(subcrops) && subcrops !== "") {
      setSubCropID(subcrops);
    }
  };


  const handleManagerTypeChange = (e) => {
    setManager(e.target.value);
    const managers = e.target.value;
    if (managers.length > 0) {
      setErrorManager("");
    }
    if (!isNaN(managers)) {
      setManager(managers);
    }
  };

  const handleMobileNbr = (e) => {
    const Input = e.target.value;
    if (Input.length > 0) {
      setErrorMobileNumber("");
    }
    let result = Input.replace(/[^0-9]/g, ""); // Remove non-digit characters
    if (result.length > 10) {
      result = result.substr(0, 10);
    }
    if (Input.length < 10) {
      setErrorMobileNumber("Please Enter 10 digit mobile number");
    }
    if (/^[6-9]/.test(result)) {
      setMobileNumber(result);
    } else {
      setMobileNumber("");
    }
  };


  const handleDateChange = (event) => {
    const newDob = event.target.value; //alert(newDob);
    const dateParts = newDob.split("-");
    if (dateParts.length === 3) {
      const selectedDateObj = new Date(newDob);
      const currentDate = new Date();
      if (selectedDateObj <= currentDate) {
        const yyyy = selectedDateObj.getFullYear();
        let mm = selectedDateObj.getMonth() + 1;
        let dd = selectedDateObj.getDate();

        if (dd < 10) dd = "0" + dd;
        if (mm < 10) mm = "0" + mm;

        setDob(newDob);
        setdmydob(dd + "-" + mm + "-" + yyyy);
        //alert(dd + '-' + mm + '-' + yyyy);
        setErrorDob("");
        setErrorfutureDate("");
      } else {
        setErrorfutureDate("Date of birth cannot be a future date");
        setDob("");
      }
      if (newDob.length === 0) {
        setErrorDob("Date of birth is required");
      } else {
        setErrorDob("");
      }
    } else {
      setErrorDob("Invalid date format (DD-MM-YYYY)");
      setErrorfutureDate("");
    }
  };


  const handleDateOfJoining = (date) => {
    if (!date) {
      setDateOfJoining(null);
      setDmyDateOfJoining("");
      setErrDateOfJoining("Please select a date.");
      return;
    }

    const yyyy = date.getFullYear();
    let mm = date.getMonth() + 1;
    let dd = date.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    // DatePicker selected value
    setDateOfJoining(date);

    // Store formatted date as dd-MM-yyyy
    setDmyDateOfJoining(`${dd} -${mm} -${yyyy} `);

    // Clear validation error
    setErrDateOfJoining("");

    // API format if required
    const formattedSubmittedDate = moment(date).format("YYYY-MM-DD");

    console.log("Formatted Submitted Date:", formattedSubmittedDate);
  };


  const handleAddressChange = (event) => {
    const inputValue = event.target.value;
    if (inputValue.length > 0) {
      setErrorAddress("");
    }
    const regex = /^[a-zA-Z0-9!@#$%^&*()_+=[\]{};':"|,.<>/? ]+$/;
    if (inputValue === "" || regex.test(inputValue)) {
      const formattedInput = inputValue.replace(
        /\b[a-z]/g,
        (char) => char.toUpperCase()
      );
      setAddress(formattedInput);
    } else {
      console.log("Invalid address format");
    }
  };

  const handleGenderChange = (event) => {
    const selectedGender = event.target.value;
    if (selectedGender.length > 0) {
      setErrorGender("");
    }
    if (/^(male|female)$/i.test(selectedGender)) {
      setGender(selectedGender);
    } else {
    }
  };
  const handleChangeAlterMobileNumber = (e) => {
    const input = e.target.value;
    if (input.length > 0) {
      setErrorAlternateMobileNumber("");
    }
    let result = input.replace(/[^0-9]/g, ""); // Remove non-digit characters
    if (result.length > 10) {
      // Trim the number to 10 digits
      result = result.substr(0, 10);
    }
    if (/^[6-9]/.test(result)) {
      // Check if the number starts with 6, 7, 8, or 9
      setAlternateMobileNo(result);
    }
  };
  const handleEmailChange = (e) => {
    const inputEmail = e.target.value;
    if (inputEmail.length > 0) {
      setErrorEmailId("");
    }
    setEmailId(inputEmail);
    // Email validation using regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(inputEmail)) {
      setErrorEmailId("Invalid email address");
    }
  };

  const handleFileChange = (event) => {
    const selectedImage = event.target.files[0];
    if (selectedImage) {
      const reader = new FileReader();
      reader.onload = () => {
        const dataURL = reader.result;
        setprofilePicUrlShow(reader.result);
        // Remove the data URL prefix
        const base64 = dataURL.split(",")[1];
        setprofilePicUrl(base64);
        setErrorProfilePicURL(""); // Clear any previous error
      };
      reader.onerror = () => {
        setErrorProfilePicURL("Error reading the selected image.");
      };
      reader.readAsDataURL(selectedImage);
    }
  };

  const statusOptions = [
    { value: "1", label: "Active" },
    { value: "0", label: "In Active" },
  ];

  const handleStatus = (e) => {
    setStatus(e.target.value);
    if (e.target.value) {
      setErrorStatus("");
    }
  };

  const handleSubmit = () => {
    if (!functionalLeadName) {
      setErrFunctionalLead("Please Select Functional Lead");
    }

    if (costcenterID === "") {
      setErrorCostCenter("Please Select Cost Center");
    }

    if (manager === "") {
      setErrorManager("Please Select  Manager");
    }
    if (userType === "") {
      setErrorUserType("Please Select user Type");
    }

    if (!selectedEmployee) {
      setErrorFirstName("Please Select Employee");
    } else {
      setErrorFirstName("");
    }

    if (roleType === "") {
      setErrorRoleType("Please Select RoleType");
    }
    if (location === "") {
      setErrorLocation("Please Select Location");
    }

    if (!sublocation) {
      setErrSubLocation("Please Select Sub Location");
    }

    if (!cropID) {
      setErrorCrop("Please Select Main Crop");
    }

    if (!subCropID) {
      setErrorSubCrop("Please Select SubCrop");
    }

    if (!mobileNumber) {
      setErrorMobileNumber("Please Enter mobile Number");
    }
    if (dob === "") {
      setErrorDob("Please Select Dob");
    }
    if (address === "") {
      setErrorAddress("Please Enter  Address");
    }

    if (dateOfJoining === "") {
      setErrDateOfJoining("Please Select Date");
    }
    if (emailId === "") {
      setErrorEmailId("Please Enter  EmailId");
    }
    if (gender === "") {
      setErrorGender("Please Select Gender");
    }
    if (status === "") {
      setErrorStatus("Please Select Status");
    }

    if (buttonText === "Submit" && profilePicUrl === "") {
      setErrorProfilePicURL("Please Upload Profile Pic");
      return; // Prevent submit
    }

    if (
      userType !== "" &&
      roleType !== "" &&
      location !== "" &&
      functionalLead !== "" &&
      costcenterID !== "" &&
      cropID !== "" &&
      subCropID !== "" &&
      manager !== "" &&
      mobileNumber !== "" &&
      dob !== "" &&
      dateOfJoining !== "" &&
      address !== "" &&
      emailId !== "" &&
      gender !== "" &&
      sublocation !== "" &&
      status !== ""
    ) {
      if (Id === 0) {
        handlePostData();
        setIsSubmitted(true);
        setErrorFirstName("");
        setErrorUserType("");
        setErrorRoleType("");
        setErrorDob("");
        setErrSubLocation("");
        setErrorAddress("");
        setErrFunctionalLead("");
        setErrorEmailId("");
        setErrorMobileNumber("");
        setErrDateOfJoining("");
        setErrorGender("");
        setErrorStatus("");
        setErrorLocation("");
        setErrorCostCenter("");
        setErrorCrop("");
        setErrorSubCrop("");
        setErrorProfilePicURL("");
        setErrorManager("");
        setErrorAlternateMobileNumber("");
      } else {
        //  alert("update"+Id)
        setIsSubmitted(false);
        // handleUpdate();
        handlePostData();
        setIsUpdated(true);
      }
    }
  };

  const fetchData = async () => {
    // setLoading(true);
    const apiUrl = getUserMaster;
    const headers = await GetApiHeaders();
    setIsLoading(true);
    setTimeout(() => {
      axios
        .get(apiUrl, { headers })
        .then((response) => {
          setIsLoading(false);
          console.log("response", response);
          setData(response.data.response.UserMaster);
          // setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching data:", error);
        });
    }, 900);
  };

  useEffect(() => {
    fetchData(); // Fetch data immediately
    setTimeout(() => {
      getRole();
    }, 2000);
  }, []);

  const handlePostData = async () => {
    const apiUrl = addUserMaster;
    const headers = await GetApiHeaders();
    const postData = {
      Id: Id === 0 ? "" : Id.toString(),
      firstName: selectedEmployee,
      lastName: "",
      roleType: roleType.toString(),
      mobileNumber: mobileNumber,
      dob: dmydob,
      // dateOfJoining: newDateOfJoining,
      dateOfJoining: dmyDateOfJoining,
      address: address,
      alternateMobileNo: alternateMobileNo,
      emailId: emailId,
      gender: gender,
      status: status,
      locationName: location,
      subLocationName: sublocation,
      subLocationId: subLocationId,
      userType: userType,
      functionalLead: functionalLeadName,
      locationId: locationId,
      costcenterID: costcenterID.toString(),
      cropID: parseInt(cropID),
      cropName: cropName,
      subCropID: subCropID,
      subCropName: subCropName,
      profilePicUrl: profilePicUrl.toString(),
      manager: manager.toString(),
    };
    console.log("postD", postData);
    setLoading(true);
    axios
      .post(apiUrl, postData, { headers })
      .then((response) => {
        setsubmitResponse(response.data.response);
        setShowModal(false);
        setShowResponsePopup(true);
        setIsLoading(false);
        console.log("submit Response:", response);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error:", error);
      });
  };
  // const apiURL = getUserTypeMaster;
  // useEffect(() => {
  //   setLoading(true);
  //   axios
  //     .get(apiURL)
  //     .then((response) => {
  //       setDynamicOptions(response.data.response.UserTypeMaster);
  //       setLoading(false);
  //       console.log("setDynamicOptions", response);
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       console.error("Error fetching dropdown options:", error);
  //     });
  // }, [apiURL]);

  const apiURL = getUserTypeMaster;
  useEffect(() => {
    const fetchUserTypeMaster = async () => {
      try {
        setLoading(true);
        const headers = await GetApiHeaders();
        const response = await axios.get(apiURL, {
          headers: headers,
        });
        setDynamicOptions(response.data.response.UserTypeMaster);
        console.log("setDynamicOptions", response);
      } catch (error) {
        console.error("Error fetching dropdown options:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUserTypeMaster();
  }, [apiURL]);

  const getRole = async () => {
    const apiUrl = getRoleMaster;
    const headers = await GetApiHeaders();
    console.log("Dynamic Headers::", headers);
    setIsLoading(true);
    setTimeout(() => {
      setLoading(true);
      axios
        .get(apiUrl, { headers })
        .then((response) => {
          setIsLoading(false);
          console.log("responseffff", response);
          setRoleTypeOptions(response.data.response.roleMaster);
          setLoading(false);
          console.log("setRoleTypeOptions", response);
        })

        .catch((error) => {
          setIsLoading(false);
          console.error("Error fetching data:", error);
        });
    }, 900);
  };
  useEffect(() => {
    getSupportedMasters();
    getMasterData();
  }, []);
  const getMasterData = async () => {
    const apiGetmaster = getMasters;
    const headers = await GetApiHeaders();
    try {
      const response = await axios.post(apiGetmaster, {}, { headers });
      setLocationTypeOptions(response.data.response.mainStoreLocation);
      setSubLocationTypeOptions(response.data.response.storeLocation);
      console.log(
        "getmaster response---D----->",
        response.data.response.mainStoreLocation
      );
    } catch (error) {
      console.log(error);
    }
  };
  const getSupportedMasters = async () => {
    const apiUrl = getUserSupportedMasters; // Replace with your actual API endpoint
    const headers = await GetApiHeaders();
    setIsLoading(true);
    setTimeout(() => {
      setLoading(true);
      axios
        .get(apiUrl, { headers })

        .then((response) => {
          setIsLoading(false);
          console.log("getSupportedMasters", response);
          setFunctionalLead(response.data.response.functionalLead);
        })
        .catch((error) => {
          setIsLoading(false);
          console.error("Error fetching data:", error);
        });
    }, 900);
  };
  const tableRef = useRef(null);

  const handleFaEyeIconClick = async (item) => {
    if (!showResetForm) {
      setShowResetForm(true);
      setSelectedItem(item);
    }
  };
  const handleResetOpern = async (item) => {
    if (!showPasswordPopup) {
      setShowPasswordPopup(true);
      setSelectedItem(item);
    }
  };

  const closePasswordPopup = () => {
    setShowPasswordPopup(false);
  };

  const handleResetPassword = async (selectedItem) => {
    console.log(JSON.stringify(selectedItem));
    const apiUrl = resetPassword;
    const postData = {
      Id: selectedItem.id,
    };
    const headers = await GetApiHeaders();
    try {
      setIsLoading(true);
      const response = await axios.post(apiUrl, postData, { headers });
      console.log("checking resetp", response);
      setsubmitResponse(response.data.message);
      setShowResetForm(false);
      setShowModal(false);
      setShowResponsePopup(true);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };
  const handleReset = async (selectedItem) => {
    console.log(JSON.stringify(selectedItem));
    const apiUrl = resetPassword;
    const postData = {
      Id: "0",
    };
    const headers = await GetApiHeaders();
    try {
      const response = await axios.post(apiUrl, postData, { headers });
      console.log("checking resetp", response);
      setsubmitResponse(response.data.message);
      setShowPasswordPopup(false);
      setShowModal(false);
      setShowResponsePopup(true);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };
  const handleModalOpen = () => {
    setButtonText("Submit");
    setIsSubmitted(false);
    setIsUpdated(false);
    setShowModal(true);
    setId(0);
    setFirstName("");
    setUserType("");
    setRoleType("");
    setLocation("");
    setCostCenterID("");
    setCropID("");
    setSubCropID("");
    setMobileNumber("");
    setAddress("");
    setGender("");
    setDob("");
    setAlternateMobileNo("");
    setEmailId("");
    setLocation("");
    setManager("");
    setprofilePicUrl("");
    setDateOfJoining("");
    setModalData({
      id: "",
      firstName: "",
      lastName: "",
      userType: "",
      roleType: "",
      mobileNumber: "",
      dob: "",
      dateOfJoining: "",
      address: "",
      alternateMobileNo: "",
      emailId: "",
      gender: "",
      status: "",
    });
  };
  const handleClose = () => {
    setShowPopup(false);
    setShowModal(false);
    setShowWarningPopup(false);
    window.location.reload();
  };
  const handleCancel = () => {
    // setShowModal(true);
    setShowModal(false);
    setShowPopup(false);
    setShowWarningPopup(false);
    // setShowMsg('');
  };

  const handleCancel_new = () => {
    //no
    // alert("handleCancel");
    setShowModal(true);
    setShowPopup(true);
  };

  const handleresponse = () => {
    setShowResponsePopup(false);
    setShowWarningPopup(false);
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };

  const closeWarning = () => {
    setShowWarningPopup(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.split(/[-/]/);
    if (parts.length !== 3) return null;
    let dd, mm, yyyy;
    // Already yyyy-MM-dd
    if (parts[0].length === 4) {
      [yyyy, mm, dd] = parts;
    } else {
      [dd, mm, yyyy] = parts;
    }
    return new Date(
      Number(yyyy),
      Number(mm) - 1,
      Number(dd)
    );
  };

  const getImageBase64AndBlobUrl = async (imagePath) => {
    try {
      if (!imagePath) {
        return {
          base64: "",
          blobUrl: "",
        };
      }
      const fileServerAuthCode = await GetApiHeadersWithToken();
      const imageUrl = `${getFileByPath}?imagePath=${imagePath.trim()}`;
      console.log("Single Media API Call:", imageUrl);
      const response = await axios.get(imageUrl, {
        headers: {
          fileServerAuthCode: fileServerAuthCode,
        },
        responseType: "blob",
      });

      if (!response.data || response.data.size === 0) {
        return {
          base64: "",
          blobUrl: "",
        };
      }
      const blobUrl = URL.createObjectURL(response.data);
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const result = reader.result;
          if (result && result.includes(",")) {
            resolve(result.split(",")[1]);
          } else {
            resolve("");
          }
        };
        reader.onerror = reject;
        reader.readAsDataURL(response.data);
      });

      return {
        base64,
        blobUrl,
      };
    } catch (error) {
      console.error("Error loading image:", error);

      return {
        base64: "",
        blobUrl: "",
      };
    }
  };

  const getImagePath = (profilePicUrl) => {
    let imagePath = profilePicUrl?.trim() || "";

    if (imagePath.includes("?imagePath=")) {
      imagePath = imagePath.split("?imagePath=")[1];
    }

    try {
      imagePath = decodeURIComponent(imagePath);
    } catch (error) {
      console.log("Image path decode error:", error);
    }

    return imagePath.trim();
  };


  const updatedItems = (item) => {
    if (!item) {
      console.error("Item is undefined or null.");
      return;
    }
    console.log("item check", item);
    setModalData(item);
    setId(item.id);
    setUserType(item.userType?.toString() || "");
    setRoleType(item.roleType);
    setMobileNumber(item.mobileNumber);
    setDob(parseDate(item.dob));
    setdmydob(item.dob || "");
    setAddress(item.address);
    // setDateOfJoining(parseDate(item.dateOfJoining));
    // setNewDateOfJoining(item.dateOfJoining || "");
    setDateOfJoining(parseDate(item.dateOfJoining));
    setDmyDateOfJoining(item.dateOfJoining || "");
    setGender(
      item.gender === "Female" || item.gender === "female"
        ? "female"
        : item.gender === "Male" || item.gender === "male"
          ? "male"
          : ""
    );

    setLocation(item.locationName);
    setLocationId(item.locationId?.toString() || "");

    setSublocation(item.subLocationName);
    setSubLocationId(item.subLocationId?.toString() || "");

    setdmydob(item.dob);
    // setNewDateOfJoining(item.dateOfJoining);
    setDmyDateOfJoining(item.dateOfJoining || "");

    setCostCenterID(item.costCenterID);
    setCropID(item.cropID);
    setCropName(item.cropName);
    setSubCropID(item.subCropID);
    setSubCropName(item.subCropName);

    setFunctionalLeadName(item.functionalLead);
    setManager(item.manager);
    setSelectedEmployee(item.firstName);

    setAlternateMobileNo(item.alternateMobileNo);
    setEmailId(item.emailId);
    setStatus(item.status);

    // -----------------------------
    // IMAGE PATH
    // -----------------------------

    let imagePath = item.profilePicUrl?.trim() || "";
    console.log("Original profilePicUrl:", item.profilePicUrl);
    if (imagePath.includes("?imagePath=")) {
      imagePath = imagePath.split("?imagePath=")[1];
    }
    try {
      imagePath = decodeURIComponent(imagePath);
    } catch (error) {
      console.log("Image path decode error:", error);
    }

    imagePath = imagePath.trim();
    console.log("Final Image Path:", imagePath);
    // -----------------------------
    // IMAGE API
    // -----------------------------
    if (imagePath) {
      getImageBase64AndBlobUrl(imagePath)
        .then((imageResult) => {
          console.log("Image API completed:", imageResult);
          setprofilePicUrl(
            imageResult.base64
              ? [imageResult.base64]
              : []
          );
          setprofilePicUrlShow(
            imageResult.blobUrl || ""
          );
        })
        .catch((error) => {
          console.error("Image loading error:", error);
          setprofilePicUrl([]);
          setprofilePicUrlShow("");
        });
    } else {
      setprofilePicUrl([]);
      setprofilePicUrlShow("");
    }

    // -----------------------------
    // OPEN UPDATE MODAL
    // -----------------------------
    setButtonText("Update");
    console.log("Set Update called");
    setShowModal(true);
    setIsSubmitted(false);
    setIsUpdated(false);
  };

  const handleImageClick = async (request) => {
    if (!request?.imagePath) {
      console.error("Image path is missing");
      return;
    }
    try {
      let blobUrl = "";
      // Complete Media API URL
      if (request.imagePath.startsWith("https")) {
        blobUrl = await GetMediaImageBlobUrl(request.imagePath);
      }
      // Only image path
      else {
        blobUrl = await GetMediaImageUrl(
          getFileByPath,
          request.imagePath
        );
      }

      if (!blobUrl) {
        console.error("Unable to load image");
        return;
      }
      const newWindow = window.open("", "_blank");
      if (!newWindow) {
        console.error("Popup blocked by browser");
        URL.revokeObjectURL(blobUrl);
        return;
      }
      newWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Image</title>
            <style>
              html, body {
                margin: 0;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #f5f5f5;
              }
  
              img {
                max-width: 90%;
                max-height: 90%;
                object-fit: contain;
              }
            </style>
          </head>
  
          <body>
            <img src="${blobUrl}" alt="Image" />
          </body>
        </html>
      `);

      newWindow.document.close();

    } catch (error) {
      console.error("Image loading failed:", error);
    }
  };

  const fetchMobileNo = async () => {
    const apiUrl = getEmployeeDetailsBasedOnName;
    const headers = await GetApiHeaders();
    const postData = {
      employeeName: selectedEmployee,
    };
    try {
      const respons = await axios.post(apiUrl, postData, { headers });
      console.log("respons----------->", respons.data.response);
      const mobile = respons.data.response[0]?.mobileNumber || "";
      setFetchMobile(mobile);
      // Clear validation after fetching
      if (mobile) {
        setErrorMobileNumber("");
      }

    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (selectedEmployee) {
      fetchMobileNo();
    }
  }, [selectedEmployee]);
  useEffect(() => {
    if (fetchMobile) {
      setMobileNumber(fetchMobile);
    }
  }, [fetchMobile]);

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Sort complete data first
  const sortedItems = [...filteredData].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];
      if (!isNaN(aValue) && !isNaN(bValue)) {
        return sortConfig.direction === "asc"
          ? aValue - bValue
          : bValue - aValue;
      }
      const aString = aValue?.toString().toLowerCase();
      const bString = bValue?.toString().toLowerCase();
      if (aString < bString)
        return sortConfig.direction === "asc" ? -1 : 1;
      if (aString > bString)
        return sortConfig.direction === "asc" ? 1 : -1;

      return 0;
    }
    return 0;
  });

  // Pagination after sorting
  const currentItems = sortedItems.slice(indexOfFirstItem, indexOfLastItem);
  // Handle column sorting
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <HiMiniArrowsUpDown className="ms-1" size={16} />;
    }
    return sortConfig.direction === "asc" ? (
      <HiMiniArrowUp className="ms-1" size={16} />
    ) : (
      <HiMiniArrowDown className="ms-1" size={16} />
    );
  };

  return (
    <>
      <style>
        {`
        .Content_data_table th {
          padding: 10px !important;
        }
      `}
      </style>
      <body id="page-top">
        {/*  <!-- Page Wrapper --> */}
        <div id="wrapper">
          {/*  <!-- Sidebar --> */}
          <SideMenu />
          {/*  <!-- End of Sidebar --> */}
          {/*  <!-- Content Wrapper --> */}
          <div id="content-wrapper" className="d-flex flex-column">
            {/*  <!-- Main Content --> */}
            <div id="content">
              {/*  <!-- Topbar --> */}
              <Header />
              {/* ...Content Start... */}
              <div>
                <div className="container-fluid">
                  <div className="card border-0">
                    <div className="card-body pt-0 pl-1">
                      <h5 className="Roles_text">User Management</h5>
                      <div className="d-flex justify-content-between">
                        <div>
                          <h6 className="mb-0 Sub_role_text">User Master</h6>
                        </div>
                        <span
                          class="d-inline-block"
                          tabindex="0"
                          data-toggle="tooltip"
                          title="Add User Master"
                        >
                          <Button
                            variant="primary"
                            className="buttons mr-1"
                            onClick={handleModalOpen}
                          >
                            <img
                              src={Add_Icon}
                              alt="Add"
                              className="addicon"
                            />
                            Add
                          </Button>
                        </span>
                      </div>
                      <div className="mcrc_hrline"></div>
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ paddingBottom: 20 }}
                      >
                        <div className="d-flex align-items-center">
                          <label className="mr-1">Show </label>
                          <Select
                            options={[
                              { value: 10, label: '10' },
                              { value: 20, label: '20' },
                              { value: 50, label: '50' },
                            ]}
                            value={{
                              value: itemsPerPage,
                              label: String(itemsPerPage),
                            }}
                            onChange={(selected) => {
                              setItemsPerPage(selected.value);
                              setCurrentPage(1);
                            }}
                            isSearchable={false}
                            styles={customstyles}
                          />
                          &nbsp;
                          <label> Entries</label>
                        </div>
                        <div className="d-flex align-items-center">
                          <div className="search-container">
                            <img
                              src={searchIcon}
                              alt="Search"
                              className="search-icon"
                            />
                            <input
                              type="text"
                              placeholder="Type to Search..."
                              value={searchTerm}
                              onChange={(e) => handleFilter(e.target.value)}
                              className="search-input mr-2"
                            />
                            {searchTerm && (
                              <button
                                type="button"
                                className="search-clear-btn"
                                onClick={() => handleFilter("")}
                              >
                                ×
                              </button>
                            )}
                          </div>
                          &nbsp;
                          <button
                            className="btn btn-secondary buttons-excel buttons-html5 mb-0"
                            onClick={exportToExcel}
                          >
                            Download Excel
                          </button>
                        </div>
                      </div>
                      <div>
                        <div className="card data_tableCard">
                          <div
                            className="card-body"
                            style={{ overflowX: "auto" }}
                          >
                            <Table className="table table-bordered Content_data_table table-striped">
                              <Thead>
                                <Tr>
                                  <Th className="text-center text-sm opacity-80">ID</Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("functionalLead")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Functional Lead
                                      {renderSortIcon("functionalLead")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("costCenterName")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Cost Center
                                      {renderSortIcon("costCenterName")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("managerName")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Manager
                                      {renderSortIcon("managerName")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("firstName")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Employee
                                      {renderSortIcon("firstName")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("userType")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      User Type
                                      {renderSortIcon("userType")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("roleTypeName")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Role Type
                                      {renderSortIcon("roleTypeName")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("locationName")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Location Name
                                      {renderSortIcon("locationName")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("subLocationName")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Sub Location
                                      {renderSortIcon("subLocationName")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("cropName")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Crop
                                      {renderSortIcon("cropName")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("subCropName")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Sub Crop
                                      {renderSortIcon("subCropName")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("mobileNumber")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Mobile Number
                                      {renderSortIcon("mobileNumber")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("dob")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      DOB
                                      {renderSortIcon("dob")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("dateJoining")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Date of Joining
                                      {renderSortIcon("dateJoining")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("address")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Address
                                      {renderSortIcon("address")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("alternateMobileNo")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Alternate Mobile Number
                                      {renderSortIcon("alternateMobileNo")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("emailId")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Email ID
                                      {renderSortIcon("emailId")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("gender")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Gender
                                      {renderSortIcon("gender")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("profilePicUrlPath")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Profile Pic URL
                                      {renderSortIcon("profilePicUrlPath")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("status")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Status
                                      {renderSortIcon("status")}
                                    </span>
                                  </Th>

                                  <Th className="text-center text-sm opacity-80">Action</Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {currentItems.length === 0 ? ( // Check if no data is found
                                  <Tr>
                                    <Td
                                      colSpan={25}
                                      className="text-center"
                                      style={{ padding: 195, fontSize: 18 }}
                                    >
                                      Data is not available
                                    </Td>
                                  </Tr>
                                ) : (
                                  currentItems != undefined &&
                                  currentItems != null &&
                                  currentItems.map((item, i) => {
                                    var parsedDate = moment(item.dob, "DD-MM-YYYY");
                                    var dob = parsedDate.isValid() ? parsedDate.format("DD-MMM-YYYY") : "";
                                    var joiningDate = moment(item.dateOfJoining, "DD-MM-YYYY");
                                    var dateJoining = joiningDate.isValid() ? joiningDate.format("DD-MMM-YYYY") : '';
                                    return (
                                      <Tr  >
                                        <Td className="text-left ">{(currentPage - 1) * itemsPerPage + i + 1}</Td>
                                        <Td className="text-center ">
                                          {" "}
                                          {item.functionalLead}{" "}
                                        </Td>
                                        <Td className="text-center">
                                          {item.costCenterName}
                                        </Td>
                                        <Td>{item.managerName}</Td>
                                        <Td className="text-center">
                                          {item.firstName}
                                        </Td>

                                        <Td>
                                          {item.userType === "1"
                                            ? "Requester"
                                            : item.userType === "2"
                                              ? "acceptor"
                                              : item.userType === "3"
                                                ? "Technician"
                                                : "none"}
                                        </Td>
                                        <Td>{item.roleTypeName}</Td>
                                        <Td>{item.locationName}</Td>
                                        <Td>{item.subLocationName}</Td>

                                        <Td>{item.cropName}</Td>
                                        <Td>{item.subCropName}</Td>
                                        <Td className="text-end">
                                          {item.mobileNumber}
                                        </Td>
                                        <Td>{dob}</Td>
                                        <Td>{dateJoining}</Td>
                                        <Td className="text-center">
                                          {item.address}
                                        </Td>
                                        <Td className="text-end">
                                          {item.alternateMobileNo}
                                        </Td>
                                        <Td>{item.emailId}</Td>
                                        <Td>{item.gender}</Td>

                                        {/* <Td>
                                          <img
                                            src={item.profilePicUrl}
                                            style={{
                                              width: "30px",
                                              height: "40px",
                                              cursor: "pointer",
                                              border: "1px solid black",
                                            }}
                                            onClick={() =>
                                              handleImageClick(item.profilePicUrl)
                                            }
                                          />
                                        </Td> */}

                                        <Td>
                                          {item.profilePicUrl && (
                                            <span className="image-gap">
                                              <ProtectedImage
                                                imagePath={item.profilePicUrl}
                                                onClick={() =>
                                                  handleImageClick({
                                                    imagePath: item.profilePicUrl,
                                                  })
                                                }
                                              />
                                            </span>
                                          )}
                                        </Td>

                                        <Td className="text-center">
                                          {item.status === "1" ? (
                                            <span style={{ color: "#4A7729" }}>
                                              Active
                                            </span>
                                          ) : (
                                            <span style={{ color: "#FF0000" }}>
                                              In Active
                                            </span>
                                          )}
                                        </Td>

                                        <Td className="text-center">
                                          <div className="d-flex justify-content-center align-items-center gap-2">
                                            <img
                                              src={Edit_Icon}
                                              alt="Edit User Master"
                                              title="Edit User Master"
                                              className="editicon"
                                              onClick={() => updatedItems(item)}
                                            />

                                            <img
                                              src={Eye_Red}
                                              alt="Reset Password"
                                              title="Reset Password"
                                              className="eye_red"
                                              onClick={() => handleFaEyeIconClick(item)}
                                            />
                                          </div>
                                        </Td>
                                      </Tr>
                                      // }
                                    );
                                  })
                                )}
                              </Tbody>
                              {isLoading && (
                                <Loader
                                  loading={isLoading}
                                  message={"Fetching Data. Please Wait..!"}
                                  loderimage={loaderImage}
                                />
                              )}
                            </Table>
                          </div>
                          {/* Pagination */}
                          <Pagination
                            currentPage={currentPage}
                            totalItems={filteredData.length}
                            itemsPerPage={itemsPerPage}
                            currentItems={currentItems}
                            onPageChange={handlePageClick}
                          />
                          <div>
                            <Modal
                              show={showModal}
                              onHide={handleModalClose}
                              centered
                              backdrop="static"
                              keyboard={false}
                              size="lg"
                            >
                              <Modal.Header className="border-0 d-flex justify-content-center">
                                <Modal.Title> </Modal.Title>
                                <Button
                                  variant="link"
                                  className="close btn btn-danger close_btn"
                                  onClick={closeWarning}
                                >
                                  X
                                </Button>
                              </Modal.Header>
                              <Modal.Body
                                className="pl-md-5 pr-md-5 pt-0"
                                style={{ overflowY: "auto", maxHeight: "85vh" }}
                              >
                                <div className="d-flex justify-content-center mb-3 font-weight-600">
                                  <span className="modal_title">User Master</span>
                                </div>
                                <div className="row">

                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      htmlFor="functionalLead"
                                      className="label-style form-label font-weight-600 mb-0"
                                    >
                                      Functional Lead
                                    </label>
                                    <div className="input-group w-100">
                                      <Select
                                        styles={modalCustomStyles}
                                        options={(Array.isArray(functionalLead) ? functionalLead : []).map(
                                          (option) => ({
                                            value: option.functionalLead,
                                            label: option.functionalLead,
                                          })
                                        )}
                                        value={
                                          functionalLeadName
                                            ? {
                                              value: functionalLeadName,
                                              label: functionalLeadName,
                                            }
                                            : null
                                        }
                                        onChange={(selectedOption) => {
                                          handleFunctionalLead({
                                            target: {
                                              value: selectedOption?.value || "",
                                            },
                                          });
                                        }}
                                        placeholder="Select Functional Lead"
                                        isSearchable={false}
                                        isClearable
                                        className="w-100"
                                      />
                                    </div>
                                    <span style={{ color: "red" }}>
                                      {errfunctionalLead}
                                    </span>
                                  </div>

                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      htmlFor="costCenter"
                                      className="label-style form-label font-weight-600 mb-0"
                                    >
                                      Cost Center
                                    </label>

                                    <div className="input-group w-100">
                                      <Select
                                        styles={modalCustomStyles}
                                        options={costCenterOptions.map((option) => ({
                                          value: option.name,
                                          label: option.name,
                                        }))}
                                        value={
                                          costcenterID
                                            ? { value: costcenterID, label: costcenterID }
                                            : null
                                        }
                                        onChange={(selectedOption) => {
                                          if (!selectedOption) {
                                            setManager("");
                                            setSelectedEmployee("");
                                            setGetEmployee([]);
                                            setManagerTypeOptions([]);
                                          }

                                          handleCostCenterTypeChange({
                                            target: {
                                              value: selectedOption?.value || "",
                                              selectedIndex: 0,
                                              options: [
                                                {
                                                  getAttribute: (attr) =>
                                                    attr === "data-costcentrName"
                                                      ? selectedOption?.label
                                                      : null,
                                                },
                                              ],
                                            },
                                          });
                                        }}
                                        placeholder="Select CostCenter"
                                        isSearchable={false}
                                        isClearable
                                        className="w-100"
                                      />
                                    </div>
                                    <span style={{ color: "red" }}>
                                      {errorCostCenter}
                                    </span>
                                  </div>
                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      htmlFor="manager"
                                      className="label-style form-label font-weight-600 mb-0"
                                    >
                                      Manager
                                    </label>
                                    <div className="input-group w-100">
                                      <Select
                                        styles={modalCustomStyles}
                                        options={(Array.isArray(managerTypeOptions)
                                          ? managerTypeOptions
                                          : []
                                        ).map((option) => ({
                                          value: option.manager,
                                          label: option.manager,
                                        }))}
                                        value={
                                          manager
                                            ? {
                                              value: manager,
                                              label: manager,
                                            }
                                            : null
                                        }
                                        onChange={(selectedOption) => {
                                          const value = selectedOption?.value || "";

                                          handleManagerTypeChange({
                                            target: {
                                              value,
                                            },
                                          });

                                          // Clear Employee when Manager is cleared
                                          if (!value) {
                                            setSelectedEmployee("");
                                            setGetEmployee([]);
                                          }
                                        }}
                                        placeholder="Select Manager"
                                        isSearchable={false}
                                        isClearable={true}
                                        className="w-100"
                                      />
                                    </div>
                                    <span style={{ color: "red" }}>
                                      {errorManager}
                                    </span>
                                  </div>
                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      htmlFor="employee"
                                      className="label-style form-label font-weight-600 mb-0"
                                    >
                                      Employee
                                    </label>
                                    <div className="input-group w-100">
                                      <Select
                                        styles={modalCustomStyles}
                                        options={(Array.isArray(getEmployee) ? getEmployee : []).map(
                                          (option) => ({
                                            value: option.employeeName,
                                            label: option.employeeName,
                                          })
                                        )}
                                        value={
                                          selectedEmployee
                                            ? {
                                              value: selectedEmployee,
                                              label: selectedEmployee,
                                            }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          handleEmployee({
                                            target: {
                                              value: selectedOption?.value || "",
                                            },
                                          })
                                        }
                                        placeholder="Select Employee"
                                        isSearchable={false}
                                        isClearable={true}
                                        className="w-100"
                                      />
                                    </div>

                                    <span style={{ color: "red" }}>
                                      {errorFirstName}
                                    </span>
                                  </div>
                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      htmlFor="userType"
                                      className="label-style form-label font-weight-600 mb-0"
                                    >
                                      User Type
                                    </label>

                                    <div className="input-group w-100">
                                      <Select
                                        styles={modalCustomStyles}
                                        options={dynamicOptions.map((option) => ({
                                          value: option.id,
                                          label: option.name,
                                        }))}
                                        value={
                                          userType
                                            ? {
                                              value: userType,
                                              label:
                                                dynamicOptions.find(
                                                  (option) =>
                                                    String(option.id) === String(userType)
                                                )?.name || "",
                                            }
                                            : null
                                        }
                                        onChange={(selectedOption) => {
                                          const value = selectedOption?.value || "";

                                          handleUserTypeChange({
                                            target: {
                                              value,
                                            },
                                          });

                                          // Clear validation error
                                          setErrorUserType("");
                                        }}
                                        placeholder="Select User Type"
                                        isSearchable={false}
                                        isClearable={true}
                                        className="w-100"
                                      />
                                    </div>

                                    <span style={{ color: "red" }}>
                                      {errorUserType}
                                    </span>
                                  </div>
                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      htmlFor="roleType"
                                      className="label-style form-label font-weight-600 mb-0"
                                    >
                                      Role Type
                                    </label>

                                    <div className="input-group w-100">
                                      <Select
                                        styles={modalCustomStyles}
                                        options={roleTypeOptions
                                          ?.filter((option) => option.status == 1)
                                          .map((option) => ({
                                            value: String(option.id),
                                            label: option.roleName,
                                          })) || []}
                                        value={
                                          roleType
                                            ? roleTypeOptions
                                              ?.filter((option) => option.status == 1)
                                              .map((option) => ({
                                                value: String(option.id),
                                                label: option.roleName,
                                              }))
                                              .find(
                                                (option) => option.value === String(roleType)
                                              ) || null
                                            : null
                                        }
                                        onChange={(selectedOption) => {
                                          const value = selectedOption?.value || "";

                                          handleRoleTypeChange({
                                            target: {
                                              value,
                                            },
                                          });

                                          setErrorRoleType("");
                                        }}
                                        placeholder="Select Role Type"
                                        isSearchable={false}
                                        isClearable
                                        className="w-100"
                                      />
                                    </div>

                                    <span style={{ color: "red" }}>
                                      {errorRoleType}
                                    </span>
                                  </div>

                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      htmlFor="location"
                                      className="label-style form-label font-weight-600 mb-0"
                                    >
                                      Location
                                    </label>

                                    <div className="input-group w-100">
                                      <Select
                                        styles={modalCustomStyles}
                                        options={locationTypeOptions.map((option) => ({
                                          value: option.name,
                                          label: option.name,
                                          code: option.code,
                                        }))}
                                        value={
                                          location
                                            ? {
                                              value: location,
                                              label: location,
                                            }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          handleLocationTypeChange({
                                            target: {
                                              value: selectedOption?.value || "",
                                              selectedIndex: 0,
                                              options: [
                                                {
                                                  getAttribute: (attr) =>
                                                    attr === "data-locationId"
                                                      ? selectedOption?.code || ""
                                                      : null,
                                                },
                                              ],
                                            },
                                          })
                                        }
                                        placeholder="Select Location"
                                        isSearchable={false}
                                        isClearable={true}
                                        className="w-100"
                                      />
                                    </div>

                                    <span style={{ color: "red" }}>
                                      {errorLocation}
                                    </span>
                                  </div>
                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      htmlFor="subLocation"
                                      className="label-style form-label font-weight-600 mb-0"
                                    >
                                      Sub Location
                                    </label>

                                    <div className="input-group w-100">
                                      <Select
                                        styles={modalCustomStyles}
                                        options={subLocationTypeOptions.map((option) => ({
                                          value: option.name,
                                          label: option.name,
                                          code: option.code,
                                        }))}
                                        value={
                                          sublocation
                                            ? {
                                              value: sublocation,
                                              label: sublocation,
                                            }
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          handleSubLocation({
                                            target: {
                                              value: selectedOption?.value || "",
                                              selectedIndex: 0,
                                              options: [
                                                {
                                                  getAttribute: (attr) =>
                                                    attr === "data-sublocationId"
                                                      ? selectedOption?.code || ""
                                                      : null,
                                                },
                                              ],
                                            },
                                          })
                                        }
                                        placeholder="Select Sub Location"
                                        isSearchable={false}
                                        isClearable={true}
                                        className="w-100"
                                      />
                                    </div>
                                    <span style={{ color: "red" }}>
                                      {errSubLocation}
                                    </span>
                                  </div>
                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      htmlFor="cropType"
                                      className="label-style form-label font-weight-600 mb-0"
                                    >
                                      Main Crop Function
                                    </label>
                                    <div className="input-group w-100">
                                      <Select
                                        styles={modalCustomStyles}
                                        options={(Array.isArray(cropTypeOptions) ? cropTypeOptions : []).map(
                                          (option) => ({
                                            value: option.cropID,
                                            label: option.cropName,
                                            cropName: option.cropName,
                                          })
                                        )}
                                        value={
                                          cropID
                                            ? (Array.isArray(cropTypeOptions)
                                              ? cropTypeOptions
                                                .map((option) => ({
                                                  value: option.cropID,
                                                  label: option.cropName,
                                                  cropName: option.cropName,
                                                }))
                                                .find(
                                                  (option) =>
                                                    String(option.value) === String(cropID)
                                                )
                                              : null) || null
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          handleCropTypeChange({
                                            target: {
                                              value: selectedOption?.value || "",
                                              selectedIndex: 0,
                                              options: [
                                                {
                                                  getAttribute: (attr) =>
                                                    attr === "data-cropName"
                                                      ? selectedOption?.cropName || ""
                                                      : null,
                                                },
                                              ],
                                            },
                                          })
                                        }
                                        placeholder="Select Crop Type"
                                        isSearchable={false}
                                        isClearable={true}
                                        className="w-100"
                                      />
                                    </div>
                                    <span style={{ color: "red" }}>
                                      {errorCrop}
                                    </span>
                                  </div>

                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      htmlFor="subCropType"
                                      className="label-style form-label font-weight-600 mb-0"
                                    >
                                      Sub Crop Function
                                    </label>
                                    <div className="input-group w-100">
                                      <Select
                                        styles={modalCustomStyles}
                                        options={
                                          (Array.isArray(subCropTypeOptions)
                                            ? subCropTypeOptions
                                            : []
                                          ).map((option) => ({
                                            value: option.subCropID,
                                            label: option.subCropName,
                                            subCropName: option.subCropName,
                                          }))
                                        }
                                        value={
                                          subCropID
                                            ? (
                                              Array.isArray(subCropTypeOptions)
                                                ? subCropTypeOptions
                                                  .map((option) => ({
                                                    value: option.subCropID,
                                                    label: option.subCropName,
                                                    subCropName: option.subCropName,
                                                  }))
                                                  .find(
                                                    (option) =>
                                                      String(option.value) === String(subCropID)
                                                  )
                                                : null
                                            ) || null
                                            : null
                                        }
                                        onChange={(selectedOption) =>
                                          handleSubCropTypeChange({
                                            target: {
                                              value: selectedOption?.value || "",
                                              selectedIndex: 0,
                                              options: [
                                                {
                                                  getAttribute: (attr) =>
                                                    attr === "data-subcropName"
                                                      ? selectedOption?.subCropName || ""
                                                      : null,
                                                },
                                              ],
                                            },
                                          })
                                        }
                                        placeholder="Select Sub Crop"
                                        isSearchable={false}
                                        isClearable={true}
                                        className="w-100"
                                      />
                                    </div>

                                    <span style={{ color: "red" }}>
                                      {errorSubCrop}
                                    </span>
                                  </div>

                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      htmlFor="exampleInputPassword1"
                                      className="label-style form-label  font-weight-600 mb-0"
                                    >
                                      Mobile Number
                                    </label>
                                    <div className="input-group input-group w-100">
                                      <input
                                        type="number"
                                        className="form-control p-2"
                                        placeholder="Mobile Number"
                                        value={mobileNumber}
                                        onChange={handleMobileNbr}
                                      />
                                    </div>
                                    <span style={{ color: "red" }}>
                                      {errorMobileNumber}
                                    </span>
                                  </div>

                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      htmlFor="exampleInputPassword1"
                                      className="label-style form-label  font-weight-600 mb-1"
                                    >
                                      DOB
                                    </label>
                                    <div className="input-group input-group w-100">
                                      <DatePicker
                                        showIcon
                                        className="form-control w-100 custom-date-input"
                                        placeholderText="Select DOB"
                                        selected={dob}
                                        onChange={(date) => {
                                          setDob(date);

                                          if (date) {
                                            const yyyy = date.getFullYear();
                                            let mm = date.getMonth() + 1;
                                            let dd = date.getDate();

                                            if (dd < 10) dd = "0" + dd;
                                            if (mm < 10) mm = "0" + mm;

                                            setdmydob(`${dd}-${mm}-${yyyy}`);
                                            setErrorDob("");
                                            setErrorfutureDate("");
                                          }
                                        }}
                                        maxDate={new Date()}
                                        dateFormat="dd-MMM-yyyy"
                                        id="dob"
                                        name="dob"
                                        customInput={<CustomDatePickerInput />}
                                        showMonthDropdown
                                        showYearDropdown
                                        yearDropdownItemNumber={100}
                                        scrollableYearDropdown
                                        dropdownMode="scroll"
                                      />

                                    </div>
                                    <span style={{ color: "red" }}>
                                      {errorDob}
                                      {errorfutureDate}
                                    </span>
                                  </div>

                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      htmlFor="dateOfJoining"
                                      className="label-style form-label font-weight-600 mb-0"
                                    >
                                      Date Of Joining
                                    </label>

                                    <div className="input-group input-group w-100">
                                      <DatePicker
                                        showIcon
                                        className="form-control w-100 custom-date-input"
                                        placeholderText="Select Date Of Joining"
                                        selected={dateOfJoining}
                                        onChange={(date) => {
                                          setDateOfJoining(date);

                                          if (date) {
                                            const yyyy = date.getFullYear();
                                            let mm = date.getMonth() + 1;
                                            let dd = date.getDate();

                                            if (dd < 10) dd = "0" + dd;
                                            if (mm < 10) mm = "0" + mm;

                                            setDmyDateOfJoining(`${dd}-${mm}-${yyyy}`);

                                            setErrDateOfJoining("");
                                          }
                                        }}
                                        maxDate={new Date()}
                                        dateFormat="dd-MMM-yyyy"
                                        id="dateOfJoining"
                                        name="dateOfJoining"
                                        customInput={<CustomDatePickerInput />}
                                        showMonthDropdown
                                        showYearDropdown
                                        yearDropdownItemNumber={100}
                                        scrollableYearDropdown
                                        dropdownMode="scroll"
                                      />
                                    </div>

                                    <span style={{ color: "red" }}>
                                      {errDateOfJoining}
                                    </span>
                                  </div>

                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      for="Inputnbr"
                                      class="form-label  font-weight-600 mb-0"
                                    >
                                      Alternate Mobile Number
                                    </label>

                                    <div className="input-group input-group w-100">
                                      <input
                                        type="number"
                                        className="form-control p-2"
                                        placeholder=""
                                        value={alternateMobileNo}
                                        onChange={handleChangeAlterMobileNumber}
                                      />
                                    </div>
                                    <span style={{ color: "red" }}>
                                      {errorAlternateMobileNumber}
                                    </span>
                                  </div>

                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      for="exampleInputEmail"
                                      class="label-style form-label  font-weight-600 mb-0"
                                    >
                                      Email-Id
                                    </label>
                                    <div className="input-group input-group w-100">
                                      <input
                                        type="text"
                                        className="form-control p-2"
                                        placeholder="Email-Id"
                                        value={emailId}
                                        onChange={handleEmailChange}
                                      />
                                    </div>
                                    <span style={{ color: "red" }}>
                                      {errorEmailId}
                                    </span>
                                  </div>

                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      for="Input"
                                      className="label-style form-label  font-weight-600 mb-0"
                                    >
                                      Address
                                    </label>
                                    <div className="input-group input-group w-100">
                                      <textarea
                                        type="text"
                                        className="form-control p-2"
                                        placeholder="Address"
                                        value={address}
                                        onChange={handleAddressChange}
                                        style={{
                                          minHeight: "80px",
                                          resize: "vertical",
                                        }}
                                      />
                                    </div>
                                    <span style={{ color: "red" }}>
                                      {errorAddress}
                                    </span>
                                  </div>

                                  <div className="col-md-6 col-12 mt-3">
                                    <label
                                      htmlFor="exampleInputGender"
                                      className="label-style form-label font-weight-600 mb-0"
                                    >
                                      Gender
                                    </label>

                                    <div className="d-flex align-items-center mt-2">
                                      <div className="form-check">
                                        <input
                                          type="radio"
                                          name="gender"
                                          id="genderMale"
                                          value="male"
                                          checked={gender === "male"}
                                          onChange={handleGenderChange}
                                          style={{
                                            transform: "scale(1.3)",
                                            cursor: "pointer",
                                            marginRight: "8px",
                                          }}
                                        />
                                        <label className="form-check-label" htmlFor="genderMale">
                                          Male
                                        </label>
                                      </div>

                                      <div className="form-check ms-3">
                                        <input
                                          type="radio"
                                          name="gender"
                                          id="genderFemale"
                                          value="female"
                                          checked={gender === "female"}
                                          onChange={handleGenderChange}
                                          style={{
                                            transform: "scale(1.3)",
                                            cursor: "pointer",
                                            marginRight: "8px",
                                          }}
                                        />
                                        <label className="form-check-label" htmlFor="genderFemale">
                                          Female
                                        </label>
                                      </div>
                                    </div>

                                    <span style={{ color: "red" }}>{errorGender}</span>
                                  </div>

                                  <div className="col-md-6 col-12 mt-2">
                                    <label
                                      for="Input"
                                      className="label-style form-label  font-weight-600 mb-0"
                                    >
                                      Status
                                    </label>
                                    <div className="input-group w-100">
                                      <Select
                                        options={statusOptions}
                                        value={statusOptions.find((option) => option.value === status)}
                                        onChange={(selectedOption) =>
                                          handleStatus({
                                            target: {
                                              value: selectedOption?.value || "",
                                            },
                                          })
                                        }
                                        placeholder="Select Status"
                                        styles={modalCustomStyles}
                                        className="w-100"
                                      />
                                    </div>
                                    <span style={{ color: "red" }}>
                                      {errorStatus}
                                    </span>
                                  </div>

                                  <div className=" col-md-6 col-12 mt-2">
                                    <label>
                                      User Profile{" "}
                                      <span style={{ color: "red" }}>*</span>
                                      <input
                                        type="file"
                                        onChange={handleFileChange}
                                        accept="image/*"
                                        className="mt-2"
                                      />
                                      <img
                                        src={UploadFile}
                                        style={{ height: 70 }}
                                      />
                                    </label>
                                    {profilePicUrlShow && (
                                      <div>
                                        <p>Uploaded Image :</p>
                                        <img
                                          src={profilePicUrlShow}
                                          alt="Selected"
                                          style={{
                                            maxHeight: "80px",
                                            maxWidth: "50%",
                                            border: "1px solid black",
                                          }}
                                        />
                                      </div>
                                    )}
                                    {errorProfilePicURL && (
                                      <p style={{ color: "red" }}>
                                        {errorProfilePicURL}
                                      </p>
                                    )}
                                  </div>

                                </div>
                                &nbsp;
                                <div className="d-flex justify-content-center col-md-12">
                                  <Button
                                    variant="primary"
                                    className="btnn"
                                    onClick={() => handleSubmit()}
                                  >
                                    {buttonText}
                                  </Button>
                                  <div style={{ width: "20px" }}></div>
                                  <Button
                                    onClick={handleCancel_new}
                                    className="btnn btn btn-danger"
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              </Modal.Body>
                            </Modal>
                          </div>
                          <div>
                            <Modal
                              show={showPopup}
                              onHide={handleModalClose}
                              centered
                              backdrop="static"
                              keyboard={false}
                              size="ml"
                            >
                              <Modal.Header className="border-0 d-flex justify-content-center">
                                <Modal.Title>
                                  {" "}
                                  <span className="modal_title">User Master</span>
                                </Modal.Title>

                                <Button
                                  variant="link"
                                  className="close btn btn-danger close_btn"
                                  onClick={closeWarning}
                                >
                                  X
                                </Button>
                              </Modal.Header>

                              <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                                <div className="d-flex justify-content-center mb-3 font-weight-600">
                                  {showMsg ? (
                                    <p className="text-center Popup_Text_Colour" >
                                      Are You Sure, Do You want close the Window ?
                                    </p>
                                  ) : null}
                                </div>
                                <div className="d-flex justify-content-center">
                                  <Button
                                    variant="primary"
                                    className="d-flex justify-content-center cancel_button"
                                    onClick={handleClose}
                                  >
                                    Yes
                                  </Button>
                                  &nbsp;&nbsp;
                                  <Button
                                    variant="danger"
                                    className="d-flex justify-content-center cancel_button"
                                    onClick={handleCancel}
                                  >
                                    No
                                  </Button>
                                </div>
                              </Modal.Body>
                            </Modal>
                          </div>
                          <div>
                            <Modal
                              show={showWarningPopup}
                              onHide={handleModalClose}
                              centered
                              backdrop="static"
                              keyboard={false}
                              size="ml"
                            >
                              <Modal.Header className="border-0 d-flex justify-content-center">
                                <Modal.Title>
                                  {" "}
                                  <span className="modal_title">User Master</span>
                                </Modal.Title>
                                <Button
                                  variant="link"
                                  className="close btn btn-danger close_btn"
                                  onClick={handleCancel}
                                >
                                  X
                                </Button>
                              </Modal.Header>
                              <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                                <div className="d-flex justify-content-center mb-3 font-weight-600">
                                  {showMsg ? (
                                    <p style={{ color: "#4A7729" }}>
                                      Are you Sure, Do You want close Window ?
                                    </p>
                                  ) : null}
                                </div>
                                <div className="d-flex justify-content-center">
                                  <Button
                                    variant="primary"
                                    className="d-flex justify-content-center cancel_button"
                                    onClick={handleClose}
                                  >
                                    Yes
                                  </Button>
                                  &nbsp;&nbsp;
                                  <Button
                                    variant="danger"
                                    className="d-flex justify-content-center cancel_button"
                                    onClick={handleCancel}
                                  >
                                    No
                                  </Button>
                                </div>
                              </Modal.Body>
                            </Modal>
                          </div>
                          <div>
                            <Modal
                              show={showResponsePopup}
                              centered
                              backdrop="static"
                              keyboard={false}
                              size="ml"
                            >
                              <Modal.Header className="border-0 d-flex justify-content-center">
                                <Modal.Title>
                                  {" "}
                                  <span className="modal_title">User Master</span>
                                </Modal.Title>
                                <Button
                                  variant="link"
                                  className="close btn btn-danger close_btn"
                                  onClick={closeWarning}
                                >
                                  X
                                </Button>
                              </Modal.Header>
                              <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                                <div className="d-flex justify-content-center mb-3 font-weight-600">
                                  {showMsg ? (
                                    <p style={{ color: "#4A7729" }}>
                                      {submitResponse}
                                    </p>
                                  ) : null}
                                </div>
                                <div className="d-flex justify-content-center">
                                  <Button
                                    variant="primary"
                                    className="d-flex justify-content-center cancel_button"
                                    onClick={handleresponse}
                                  >
                                    Okay
                                  </Button>
                                  &nbsp;&nbsp;
                                </div>
                              </Modal.Body>
                            </Modal>
                          </div>
                          <div>
                            <Modal
                              show={showPasswordPopup}
                              centered
                              onHide={() => setShowPasswordPopup(false)}
                            >
                              <Modal.Header>
                                <Modal.Title>Reset Password</Modal.Title>
                                <Button
                                  variant="link"
                                  className="close btn btn-danger close_btn"
                                  onClick={closeWarning}
                                >
                                  X
                                </Button>
                              </Modal.Header>
                              <Modal.Body>
                                <div className="d-flex justify-content-center mb-3 font-weight-600">
                                  <p style={{ color: "#4A7729" }}>
                                    Are You Sure, do you want to reset the
                                    password?
                                  </p>
                                </div>
                              </Modal.Body>
                              <Modal.Footer className="justify-content-center">
                                <div className="d-flex justify-content-center">
                                  <Button
                                    variant="primary"
                                    className="d-flex justify-content-center cancel_button"
                                    onClick={() => handleReset(selectedItem)}
                                  >
                                    Yes
                                  </Button>
                                  &nbsp;&nbsp;
                                  <Button
                                    variant="danger"
                                    className="d-flex justify-content-center cancel_button"
                                    onClick={() => setShowPasswordPopup(false)}
                                  >
                                    No
                                  </Button>
                                </div>
                              </Modal.Footer>
                            </Modal>
                          </div>
                          <div>
                            <Modal
                              show={showResetForm}
                              centered
                              onHide={() => setShowResetForm(false)}
                            >
                              <Modal.Header>
                                <Modal.Title>Reset Password</Modal.Title>
                                <Button
                                  variant="link"
                                  className="close btn btn-danger close_btn"
                                  onClick={closeWarning}
                                >
                                  X
                                </Button>
                              </Modal.Header>
                              <Modal.Body>
                                <div className="d-flex justify-content-center mb-3 font-weight-600">
                                  <p style={{ color: "#4A7729" }}>
                                    Are You Sure, do you want to reset the
                                    password?
                                  </p>
                                </div>
                                {/* You can add more content or a password reset form here */}
                              </Modal.Body>
                              <Modal.Footer className="justify-content-center">
                                <div className="d-flex justify-content-center">
                                  <Button
                                    variant="primary"
                                    className="d-flex justify-content-center cancel_button"
                                    onClick={() =>
                                      handleResetPassword(selectedItem)
                                    }
                                  >
                                    Yes
                                  </Button>
                                  &nbsp;&nbsp;
                                  <Button
                                    variant="danger"
                                    className="d-flex justify-content-center cancel_button"
                                    // onClick={() => setShowPasswordPopup(false)}
                                    onClick={closeWarning}
                                  >
                                    No
                                  </Button>
                                </div>
                              </Modal.Footer>
                            </Modal>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* ...End of Main Content...*/}
            {/* ...Footer...*/}
            <Footer />
            {/* ... End of Footer...  */}
          </div>
        </div>
        {/*  <!-- End of Page Wrapper -->
          <!-- Scroll to Top Button--> */}
        <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
        </a>
        {/*  <!-- Logout Modal--> */}
        <Logout />
      </body>
    </>
  );
};

export default UserMaster;
